var map = {
	"./funds.json": 79911,
	"./funds_BG.json": 27563,
	"./funds_CS.json": 35386,
	"./funds_DA.json": 82439,
	"./funds_DE.json": 16859,
	"./funds_EL.json": 96749,
	"./funds_ES.json": 45140,
	"./funds_ET.json": 26965,
	"./funds_FI.json": 63933,
	"./funds_FR.json": 91080,
	"./funds_GA.json": 87068,
	"./funds_HR.json": 72874,
	"./funds_HU.json": 34919,
	"./funds_IS.json": 43720,
	"./funds_IT.json": 38033,
	"./funds_LT.json": 8000,
	"./funds_LV.json": 55154,
	"./funds_MT.json": 95661,
	"./funds_NB.json": 17520,
	"./funds_NL.json": 15478,
	"./funds_PL.json": 99028,
	"./funds_PT.json": 24012,
	"./funds_RO.json": 62755,
	"./funds_SK.json": 44098,
	"./funds_SL.json": 66143,
	"./funds_SV.json": 63297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37912;